const merge = require('lodash/merge');
const config = require('./config.common');

module.exports = merge({}, config, {
  environment: 'qa',
  isPublisherActive: true,
  app: {
    protocol: 'https',
    host: 'prog.qa.viooh.io',
    port: null,
  },
  auth0: {
    domain: 'viooh-qa.eu.auth0.com',
    clientID: 'XLwfcb7cOHWfmtYytj2gYbiZNmpgPtyH',
    audience: 'https://auth0-qa-api.viooh.com/',
    responseType: 'token id_token',
    scope: 'openid profile email offline_access',
  },
  api: {
    BASE_URL: 'https://gateway-api.qa.viooh.io/',
  },
  gatewayApi: {
    BASE_URL: 'https://gateway-api.qa.viooh.io/',
  },
  dsm: {
    BASE_URL: 'https://api.qa.viooh.io/',
  },
  thoughtspot: {
    resellerDealHealthDashboardId: 'c6864e11-e91e-4cae-b626-da7c9a2bd7eb',
    dealHealthDashboardId: '87680c73-93f3-4fe5-80db-5172a1ba569d',
    proofOfPlayLiveboardId: '00b45643-8f9d-4b5a-8fd9-79180e117ef6',
    resellerProofOfPlayLiveboardId: '08da0b9c-e33a-4b66-bca2-3394fdb28422',
    revenueInsightsLiveboardId: '1789074d-7cee-43b7-8423-f6d3c278001f',
    inventoryReservationLiveboardId: 'c008307e-2631-48d8-bc46-7d0530d6bd17',
    todaysRevenueVizId: '5a311ef5-d33d-4b42-955e-5c9812e1086b',
    monthToDateVizId: '72ef7ecf-71e4-41f1-83f9-43fb217b2da1',
    chinaProofOfPlayLiveboardId: '2a595cf7-631e-490e-b084-46740f6ca341',
    assetHealthLiveboardId: '258b2057-b681-458d-b414-e9ec2f76e96d',
  },
  dataDog: {
    defaultPrivacyLevel: 'allow',
  },
  features: (market) => {
    return {
      ...config.features(market),
      EMAIL_NOTIFICATION: true,
      GOOGLEMAPS: true,
      OVERRIDE_DEAL_ID: true,
    };
  },
});
